import currencyList from "../constants/currencies.json"

interface CurrencyOptions {
  label: string
  value: string
  desc?: string
}

export const getCurrencyList = ({excludeInternalCurrencies} = {excludeInternalCurrencies: false}): CurrencyOptions[] => {
  if (excludeInternalCurrencies) {
    return currencyList
  }

  const flexiCurrencies: CurrencyOptions[] = [
    {label: "Flexi Points", value: "TT", desc: "FlexiPoint tokens, originally referred to as treat tokens. Used for Perks"},
    {label: "Reward Points (deprecated)", value: "RP", desc: "The original Reward Point currency code before the great migration of 2024"},
    {label: "Reward Points", value: "EP", desc: "Reward Points as used for celebrations and rewards, a replacement of the old 'RP' code"},
    {label: "Merchandise Points", value: "MP", desc: "Merchant points, used to normalise different stock prices across deal providers"},
    {label: "Blend Points", value: "BLEND", desc: "BlendPoints of Rp and Fp, only exists client side"}
  ]
  return flexiCurrencies.concat(currencyList)
}

/**
 * Get the cost of tax applied to a given fee
 * all values returned in cents
 *
 * rounding calculated as per https://www.gov.uk/hmrc-internal-manuals/vat-trader-records/vatrec12030
 */
export const getTaxCost = ({
  totalBeforeTax,
  tax,
  isCents = true
}: {
  totalBeforeTax: number
  isCents?: boolean
  tax?: number
}): {
  appliedTaxPercentage: number
  taxCost: number
  totalBeforeTax: number
  totalCost: number
} => {
  const appliedTaxPercentage = tax ?? 0
  const totalBeforeTaxAsCents = isCents ? totalBeforeTax : totalBeforeTax * 100
  const taxCost = Math.round((totalBeforeTaxAsCents * appliedTaxPercentage) / 100)

  return {
    appliedTaxPercentage,
    taxCost,
    totalBeforeTax: totalBeforeTaxAsCents,
    totalCost: totalBeforeTaxAsCents + taxCost
  }
}
